export default __webpack_public_path__ + "static/media/Chip.98787b97.svg";